import script from "./AuctionFieldSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuctionFieldSection.vue?vue&type=script&setup=true&lang=ts"

import "./AuctionFieldSection.vue?vue&type=style&index=0&id=d6c6c46e&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6c6c46e"]])

export default __exports__